import type { MouseEvent } from 'react';

/**
 * What every picture, video and voice note of a child carries, so the browser offers no way to save it
 * (Q7, decision 2026-10-03 #1): no context menu, no dragging it out, and on a player no download button and
 * no picture-in-picture. `base.css` adds the iOS long-press half.
 *
 * Friction, not prevention. Developer tools, the link itself and a screenshot all still work, and nothing in
 * a browser can block a screenshot; the viewer watermark is the protection there. Nothing here claims more.
 */
export const noSave = {
  onContextMenu: (event: MouseEvent) => event.preventDefault(),
  draggable: false,
} as const;

/** {@link noSave} for a `<video>` or `<audio>` element: the player's own download button goes too. */
export const noSavePlayer = {
  ...noSave,
  controlsList: 'nodownload',
} as const;

/**
 * {@link noSavePlayer} for a `<video>`: picture-in-picture would lift it out of the page, and the player's own
 * fullscreen would leave the viewer watermark behind (`ProtectedVideo` offers one that keeps it).
 */
export const noSaveVideo = {
  ...noSave,
  controlsList: 'nodownload nofullscreen',
  disablePictureInPicture: true,
} as const;
